import React from 'react';
import { View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { WidgetCard } from './widget-card';
import { SubscriptionCardWidgetData, WidgetProps } from './widget-types';

/**
 * "Plano fixo: R$ 320 por mês" — torna concreto o que é abstrato.
 *
 * A frase vem pronta do backend justamente para que a palavra "recorrência"
 * não chegue nunca à tela do prestador.
 */
export function SubscriptionCardWidget({
  data,
}: WidgetProps<SubscriptionCardWidgetData>) {
  if (!data.plans?.length) return null;

  return (
    <WidgetCard title="Plano fixo" icon="repeat-outline">
      <View className="gap-2">
        {data.plans.map(plan => (
          <View
            key={plan.name}
            className="gap-0.5 rounded-xl bg-neutral-50 px-3 py-2.5"
          >
            <ThemedText className="text-sm font-medium text-foreground">
              {plan.name}
            </ThemedText>
            <ThemedText className="text-xs text-foreground/55">
              {plan.line ?? plan.priceLabel}
            </ThemedText>
          </View>
        ))}
      </View>
    </WidgetCard>
  );
}
